'use strict';

const Analytics = require('./analytics');

function triggerEventForRefundFlow (action, storeName) {
    $('body').trigger('analytics:refundStoreActions', {
        action,
        'store': storeName
    });
}

class AnalyticsFindYourStore extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'Analytics Find your Store';

        if ($('.page').data('action')) {
            if (($('.page').data('action').split('-')[0]).toLowerCase() == 'stores' || ($('.page').data('action').split('-')[0]).toLowerCase() == 'store') {
                super.init(globalContainer, helperContainer);
                this.prepareObservers();
            }
        }
        this.prepareStoresObservers();
    }

    prepareObservers () {
        var _self = this;

        $('body').on('storeLocator:searchWithZipCode', function (e, data) {
            var action = $('.woosmap-analytics').val();
            let sku = 'no_product';
            let city = data.stores[0].city || '';
            _self.quickImpressionSender.pushFindStoreFindInteraction(_self.helper.formatString(city), sku, action);
        });

        $('body').on('storeLocator:geolocationSucceeded', function (e, data) {
            var action = 'search_for_a_shop';
            let sku = 'no_product';
            if (data.stores[0].city != null || undefined) {
                let city = '';
                city = data.stores[0].city.toLowerCase().replace(/[\s]|[-]/g, '_');

                _self.quickImpressionSender.pushFindStoreGeolocationImpression(city, sku, action);
            } else {
                _self.quickImpressionSender.pushFindStoreGeolocationImpression('', sku, action);
            }
        });

        $('body').on('submit', 'form#findStoreFooterForm', function (e) {
            _self.quickImpressionSender.pushFindStoreFindInteraction($('#footer-find-store').val());
        });
    }
    prepareStoresObservers () {
        var _self = this;
        $('body').on('click', '.store-locator-container a, .cc-storeDetailPage a', function (e) {
            let action = $(e.currentTarget).data('name');
            if (!action || (action === 'see_the_opening_hours' && $(e.currentTarget).closest('.store-hours').find('.store-hours-list').hasClass('hidden'))) {
                return;
            }
            let storeName;
            storeName = $(e.currentTarget).closest('.store-result').find('.analytics-store-name').text();
            if (!storeName) {
                storeName = $(document).find('.store-name-link').text();
            }
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.store-page-detail-map div[role="dialog"] a', function (e) {
            let action = $(e.currentTarget).data('name');
            if (!action || (action === 'see_the_opening_hours' && $(e.currentTarget).closest('.store-hours').find('.store-hours-list').hasClass('hidden'))) {
                return;
            }
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name-link').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.js-toggle-store-hours', function (e) {
            let action = $(e.currentTarget).data('name');
            if (!action || (action === 'see_the_opening_hours' && $(e.currentTarget).closest('.store-hours').find('.store-hours-list').hasClass('hidden'))) {
                return;
            }
            let storeName = $('.js-store-details').find('.js-store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.get-directions-button', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('.store-hours').find('h4').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('analytics:clickonBlackMarker', function (e, item) {
            let action = 'click_placeholder';
            let storeName = _self.helper.formatString(item.name);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            if ($('.page').data('action') === 'Order-Details') {
                triggerEventForRefundFlow(action, storeName);
                return;
            }
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('findinstore:selectedStore', function (e, data) {
            let action = 'click_result_of_the_shops_listing';
            let storeName = _self.helper.formatString(data.storeName);
            let when = 'shipping_method';
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            if ($('.page').data('action') === 'Order-Details') {
                triggerEventForRefundFlow(action, storeName);
                return;
            }
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, when);
        });

        $('body').on('pickupPoint:selectedPoint', function (e, data) {
            let storeName = _self.helper.formatString(data.name);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#checkout-main #findinstore div[role="dialog"] .js-storelocator-phone ', function (e) {
            let action = 'phone_number';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.js-storelocator-phone', function (e) {
            let action = 'phone_number';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            if ($('.page').data('action') === 'Order-Details') {
                triggerEventForRefundFlow('phone_number', storeName);
                return;
            }
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#checkout-main #fis-results .js-store-phone', function (e) {
            let action = 'phone_number';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.js-store-phone', function (e) {
            let action = 'phone_number';
            let storeName = $(e.currentTarget).closest('.js-store-row').find('.js-store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            if ($('.page').data('action') === 'Order-Details') {
                storeName = storeName || _self.helper.formatString($(e.currentTarget).closest('.store-details').find('.store-name').text());
                triggerEventForRefundFlow('phone_number', storeName);
                return;
            }
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#checkout-main #findinstore div[role="dialog"] .store-gotomps-box a', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.fis-show-on-map, .fi-show-on-map-BPOST', function (e) {
            let store = $(e.currentTarget).closest('.js-store-row');
            let storeName = store.find('.store-name').text() ? store.find('.store-name').text() :
                store.find('.js-store-name').text() ? store.find('.js-store-name').text() : store.find('.js-pickup-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            if ($('.page').data('action') === 'Order-Details') {
                triggerEventForRefundFlow('view_in_map', storeName);
                return;
            }
            _self.quickImpressionSender.pushFindStoreClickResultAction('view_in_map', storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#checkout-main #pickupPointMapBRT div[role="dialog"] .store-gotomps-box a', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#checkout-main #pickupPointListBRT .fi-show-on-map-brt', function (e) {
            let action = 'view_in_map';
            let storeName = $(e.currentTarget).closest('.js-store-row').find('.js-pickup-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#checkout-main #pickupPointMapDHL div[role="dialog"] .store-gotomps-box a', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#checkout-main #pickupPointListDHL .fi-show-on-map-dhl', function (e) {
            let action = 'view_in_map';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.js-choose-pickup-infowindow-BPOST', function (e) {
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#checkout-main #pickupPointListBPOST .fi-show-on-map-BPOST', function (e) {
            let action = 'view_in_map';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            if (!storeName) storeName = $(e.currentTarget).closest('.distance').children('.js-pickup-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.js-choose-pickupPointBRT, .js-choose-pickup-infowindow-BRT', function (e) {
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-id'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });

        $('body').on('click', '.js-choose-pickup-infowindow-PDB', function (e) {
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-id'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#checkout-main #js-pickupPointMapPDB div[role="dialog"] .store-gotomps-box a', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#checkout-main #pickupPointListPDB .fi-show-on-map-PDB', function (e) {
            let action = 'view_in_map';
            let storeName = $(e.currentTarget).closest('.js-store-row').find('.js-pickup-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '.js-choose-pickupPointBPOST', function (e) {
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-name'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });
        $('body').on('click', '.js-choose-pickupPointEVR, .js-choose-pickup-infowindow-EVR, .js-choose-pickupPointEST, .js-choose-pickup-infowindow-EST, .js-choose-pickupPointDEL, .js-choose-pickup-infowindow-DEL, .js-choose-pickupPointGLS, .js-choose-pickup-infowindow-GLS, .js-choose-pickupPointMRE, .js-choose-pickup-infowindow-MRE, .js-choose-pickupPointGLSHU, .js-choose-pickup-infowindow-GLSHU, .js-choose-pickupPointDPD, .js-choose-pickup-infowindow-DPD, .js-choose-pickupPointFAN, .js-choose-pickup-infowindow-FAN, .js-choose-pickup-infowindow-CTT', function (e) {
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-name'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });
        $('body').on('click', '.js-choose-pickupPointPTN, .js-choose-pickup-infowindow-PTN', function (e) {
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-name'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#checkout-main #js-pickupPointMapEVR div[role="dialog"] .store-gotomps-box a, #checkout-main #js-pickupPointMapEVR div[role="dialog"] .store-gotomps-box a', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });
        $('body').on('click', '#checkout-main #js-pickupPointMapPTN div[role="dialog"] .store-gotomps-box a', function (e) {
            let action = 'get_directions';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#checkout-main #pickupPointListEVR .fi-show-on-map-EVR, #checkout-main #pickupPointListEST .fi-show-on-map-EST', function (e) {
            let action = 'view_in_map';
            let storeName = $(e.currentTarget).closest('.js-store-row').find('.js-pickup-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });
        $('body').on('click', '#checkout-main #pickupPointListPTN .fi-show-on-map-PTN', function (e) {
            let action = 'view_in_map';
            let storeName = $(e.currentTarget).closest('.js-store-row').find('.js-pickup-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });
    }
}

const obj = new AnalyticsFindYourStore();
module.exports = obj;
